import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { saveFollowUps } from "../redux/followUps/followUpsActions";
import { formatFollowUpDates } from "../utils/formatFollowUpDates";

const useCheckDuplicateWorkOrder = () => {
    const dispatch = useDispatch();
    const workOrderData = useSelector((state) => state.tasks.workorderData.workorderData);
    const userInfo = useSelector((state) => state.login.userInfo);
    const technicianInfo = useSelector((state) => state.login.technicianInfo);

    const createUserProfile = (flow = "") => ({
        sub: userInfo.sub,
        email_verified: userInfo.email_verified,
        adGroup: flow?.includes("admin") ? ["/CmisAdmin"] : ["/CmisLabourer"],
        name: userInfo.name,
        preferred_username: userInfo.preferred_username,
        given_name: userInfo.given_name,
        family_name: userInfo.family_name,
        employeeNumber: technicianInfo.pein,
    });

    const selectDueDate = (followUp, flow) => {
        const getLeadTimeDate = () => {
            const leadTime = followUp?.leadTime;
            return leadTime ? moment().businessAdd(leadTime)._d : moment();
        };

        switch (flow) {
            case "admin_incomplete":
                return formatFollowUpDates(workOrderData.originalDueDate || moment());
            case "admin_complete":
            case "labourer_complete":
                return formatFollowUpDates(getLeadTimeDate());
            default:
                return followUp?.dueDate || formatFollowUpDates(moment());
        }
    };

    const formatFollowUp = (followUp, flow) => ({
        uuid: followUp.uuid,
        id: followUp.id || null,
        taskId: workOrderData?.taskId ? workOrderData.taskId : null,
        followUpTpyeId: followUp.followUpTpyeId,
        creationDate: formatFollowUpDates(new Date()),
        dueDate: selectDueDate(followUp, flow),
        comments: followUp.comments ?? null,
        new: followUp.new,
        validatedForDoubles: false,
        duplicateWorkOrdersDTO: null,
    });

    const checkDuplicateWorkOrder = (
        followUp,
        deletedFollowUpIds,
        flow = "admin_incomplete",
        refresh = true,
        payload = { popupOpen: true },
        workOrderNumber,
    ) => {
        const followUpInfo = {
            userProfile: createUserProfile(flow),
            relatedID: workOrderData.workOrderNumber ?? workOrderNumber,
            dueDate: workOrderData.originalDueDate,
            followUpList: [formatFollowUp(followUp, flow)],
            deletedFollowUps: deletedFollowUpIds,
        };

        dispatch(saveFollowUps(followUpInfo, workOrderData.workOrderNumber, refresh, payload));
    };

    return {
        checkDuplicateWorkOrder,
    };
};

export default useCheckDuplicateWorkOrder;
